import merge from "deepmerge";
import { pickBy } from 'lodash';
var combineMerge = function (target, source, options) {
  var destination = target.slice();
  source.forEach(function (item, index) {
    if (typeof destination[index] === 'undefined') {
      destination[index] = options.cloneUnlessOtherwiseSpecified(item, options);
    } else if (options.isMergeableObject(item)) {
      destination[index] = merge(target[index], pickBy(item, function (val, key) {
        return val !== null && val !== undefined;
      }), options);
    } else if (target.indexOf(item) === -1) {
      destination.push(item);
    }
  });
  return destination;
};
export function overlayMerge(target, source) {
  return merge(target, source, {
    arrayMerge: combineMerge
  });
}